import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { getProjects } from '../data/projects';

/* ============================================================
   STYLE — injecté dans le <head> pour ne pas dépendre du CSS global
============================================================ */
const STYLES = `
  /* ---- Reset page ---- */
  .up-page { padding-top: 64px; min-height: 100vh; background: #0a0a0a; }

  /* ---- TOP BAR ---- */
  .up-topbar {
    display: flex; align-items: center; justify-content: space-between;
    gap: 20px; flex-wrap: wrap;
    padding: 28px 80px;
    background: #111;
    border-bottom: 1px solid rgba(255,255,255,0.07);
  }
  .up-topbar-left {}
  .up-topbar-eyebrow {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.65rem; font-weight: 700; letter-spacing: 0.22em;
    text-transform: uppercase; color: #7b10e0; margin-bottom: 6px;
    display: flex; align-items: center; gap: 8px;
  }
  .up-topbar-eyebrow::before { content: ''; width: 18px; height: 1px; background: #7b10e0; }
  .up-topbar-title {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: clamp(1.8rem, 4vw, 3.2rem); font-weight: 900;
    text-transform: uppercase; line-height: 0.95; color: #f0f0f0;
  }
  .up-topbar-title span {
    background: linear-gradient(90deg, #7b10e0 0%, #a855f7 50%, #00E5FF 100%);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
  }
  .up-topbar-actions { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }

  /* ---- BUTTONS ---- */
  .up-btn {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.82rem; font-weight: 700; letter-spacing: 0.12em;
    text-transform: uppercase; padding: 12px 24px; cursor: pointer;
    transition: all 0.2s; border: none; display: inline-flex; align-items: center; gap: 8px;
    text-decoration: none; white-space: nowrap;
  }
  .up-btn-primary { background: #7b10e0; color: #fff; }
  .up-btn-primary:hover { background: #6209b8; transform: translateY(-2px); }
  .up-btn-ghost { background: transparent; border: 1px solid rgba(255,255,255,0.12); color: #f0f0f0; }
  .up-btn-ghost:hover { border-color: #7b10e0; color: #7b10e0; }
  .up-btn-danger { background: transparent; border: 1px solid rgba(255,68,68,0.25); color: #ff5555; }
  .up-btn-danger:hover { background: rgba(255,68,68,0.1); border-color: #ff5555; }
  .up-btn-sm { padding: 8px 16px; font-size: 0.72rem; }

  /* ---- SELECTOR BAR ---- */
  .up-selector {
    display: flex; align-items: center; gap: 12px; flex-wrap: wrap;
    padding: 16px 80px;
    background: #0e0e0e;
    border-bottom: 1px solid rgba(255,255,255,0.07);
  }
  .up-selector-label {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.65rem; font-weight: 700; letter-spacing: 0.18em;
    text-transform: uppercase; color: #666; white-space: nowrap;
  }
  .up-selector select {
    background: #181818; border: 1px solid rgba(255,255,255,0.07);
    color: #f0f0f0; font-family: 'Barlow', sans-serif; font-size: 0.88rem;
    padding: 10px 14px; outline: none; cursor: pointer;
    transition: border-color 0.2s; appearance: none; min-width: 220px;
  }
  .up-selector select:focus { border-color: #7b10e0; }
  .up-selector select option { background: #181818; }
  .up-selector-sep { color: rgba(255,255,255,0.1); }
  .up-selector-link {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.7rem; font-weight: 700; letter-spacing: 0.12em;
    text-transform: uppercase; color: #555; text-decoration: none;
    transition: color 0.2s;
  }
  .up-selector-link:hover { color: #f0f0f0; }

  /* ---- LAYOUT PRINCIPAL ---- */
  .up-body { }

  /* ---- SECTION WRAPPER ---- */
  .up-section {
    padding: 56px 80px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
  }
  .up-section-inner-2col {
    display: grid; grid-template-columns: 1.3fr 0.7fr; gap: 60px; align-items: start;
  }
  .up-section-eyebrow {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.62rem; font-weight: 700; letter-spacing: 0.22em;
    text-transform: uppercase; color: #7b10e0; margin-bottom: 24px;
    display: flex; align-items: center; gap: 10px;
  }
  .up-section-eyebrow::before { content: ''; width: 20px; height: 1px; background: #7b10e0; }

  /* ---- TITRE PREVIEW (gros comme Projet.jsx) ---- */
  .up-title-preview {
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 900; font-size: clamp(2.5rem, 6vw, 5.5rem);
    line-height: 0.9; text-transform: uppercase;
    margin-bottom: 28px; letter-spacing: -0.01em;
    color: rgba(255,255,255,0.1);
    transition: color 0.3s;
    word-break: break-word;
  }
  .up-title-preview.active { color: #f0f0f0; }

  /* ---- CHAMPS ---- */
  .up-field { margin-bottom: 18px; }
  .up-field-label {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.58rem; font-weight: 700; letter-spacing: 0.22em;
    text-transform: uppercase; color: #555;
    margin-bottom: 7px;
    display: flex; align-items: center; justify-content: space-between;
  }
  .up-field-label em { color: #7b10e0; font-style: normal; }
  .up-field-label small { font-weight: 300; text-transform: none; letter-spacing: 0; color: #444; }
  .up-field input, .up-field textarea, .up-field select {
    width: 100%;
    background: #141414; border: 1px solid rgba(255,255,255,0.08);
    color: #f0f0f0; font-family: 'Barlow', sans-serif;
    font-size: 0.88rem; font-weight: 300;
    padding: 13px 16px; outline: none;
    transition: border-color 0.2s; appearance: none;
    line-height: 1.5;
  }
  .up-field input:focus, .up-field textarea:focus, .up-field select:focus { border-color: #7b10e0; }
  .up-field input::placeholder, .up-field textarea::placeholder { color: #333; }
  .up-field input.err, .up-field textarea.err { border-color: #ff4444 !important; }
  .up-field textarea { resize: vertical; }
  .up-field select { cursor: pointer; }
  .up-field select option { background: #141414; }
  .up-field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

  /* ---- OUTILS TAGS ---- */
  .up-tools-wrap { display: flex; gap: 6px; flex-wrap: wrap; margin-bottom: 8px; min-height: 28px; }
  .up-tool-tag {
    display: inline-flex; align-items: center; gap: 6px;
    font-family: 'Space Mono', monospace; font-size: 0.6rem;
    border: 1px solid rgba(123,16,224,0.4); color: #7b10e0;
    padding: 4px 10px; background: rgba(123,16,224,0.08);
  }
  .up-tool-remove {
    background: none; border: none; color: #7b10e0;
    cursor: pointer; font-size: 0.65rem; padding: 0;
    opacity: 0.5; transition: opacity 0.2s; line-height: 1;
  }
  .up-tool-remove:hover { opacity: 1; }
  .up-tool-add {
    display: flex; gap: 8px;
  }
  .up-tool-add input {
    flex: 1; background: #141414; border: 1px solid rgba(255,255,255,0.08);
    color: #f0f0f0; font-family: 'Space Mono', monospace; font-size: 0.72rem;
    padding: 8px 12px; outline: none; transition: border-color 0.2s;
  }
  .up-tool-add input:focus { border-color: #7b10e0; }
  .up-tool-add input::placeholder { color: #333; }

  /* ---- SIDEBAR META ---- */
  .up-meta-block {
    background: #111; border: 1px solid rgba(255,255,255,0.07);
    overflow: hidden;
  }
  .up-meta-row {
    padding: 18px 20px; border-bottom: 1px solid rgba(255,255,255,0.05);
    position: relative;
  }
  .up-meta-row::before {
    content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 2px;
    background: #7b10e0; transform: scaleY(0); transform-origin: bottom;
    transition: transform 0.3s;
  }
  .up-meta-row:focus-within::before { transform: scaleY(1); }
  .up-meta-row:last-child { border-bottom: none; }
  .up-meta-row-label {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.55rem; font-weight: 700; letter-spacing: 0.22em;
    text-transform: uppercase; color: #444; margin-bottom: 6px;
  }
  .up-meta-row input {
    width: 100%; background: transparent; border: none;
    color: #f0f0f0; font-family: 'Barlow', sans-serif;
    font-size: 0.88rem; font-weight: 400; padding: 0; outline: none;
    transition: color 0.2s;
  }
  .up-meta-row input::placeholder { color: #333; }
  .up-meta-row input.err { color: #ff5555; }

  /* ---- IMAGE UPLOAD ---- */
  .up-img-zone {
    border: 1px dashed rgba(255,255,255,0.1);
    background: #111; overflow: hidden;
    position: relative; cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
  }
  .up-img-zone:hover { border-color: #7b10e0; background: #130820; }
  .up-img-zone.dragover { border-color: #7b10e0; background: #130820; }
  .up-img-zone input[type="file"] {
    position: absolute; inset: 0; opacity: 0; cursor: pointer;
    z-index: 2; width: 100%; height: 100%;
  }
  .up-img-placeholder {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 8px; pointer-events: none; padding: 32px 16px;
  }
  .up-img-icon { font-size: 1.6rem; opacity: 0.15; }
  .up-img-text {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.72rem; font-weight: 700; letter-spacing: 0.14em;
    text-transform: uppercase; color: #444;
  }
  .up-img-sub { font-size: 0.65rem; color: #333; }
  /* Hero image — grande */
  .up-img-zone.hero .up-img-placeholder { min-height: 260px; }
  .up-img-zone.hero img { width: 100%; display: block; max-height: 340px; object-fit: cover; }
  /* Galerie — petite */
  .up-img-zone.thumb .up-img-placeholder { min-height: 180px; }
  .up-img-zone.thumb img { width: 100%; display: block; height: 180px; object-fit: cover; }
  .up-img-remove {
    position: absolute; top: 8px; right: 8px; z-index: 3;
    background: rgba(0,0,0,0.75); border: 1px solid rgba(255,255,255,0.12);
    color: #f0f0f0; font-size: 0.65rem; padding: 5px 10px; cursor: pointer;
    font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
    letter-spacing: 0.1em; text-transform: uppercase; transition: all 0.2s;
  }
  .up-img-remove:hover { background: rgba(255,68,68,0.5); border-color: #ff4444; }

  /* ---- SECTION IMAGE HERO ---- */
  .up-hero-img-wrap { padding: 0 80px 56px; border-bottom: 1px solid rgba(255,255,255,0.07); }
  .up-block-label {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.62rem; font-weight: 700; letter-spacing: 0.2em;
    text-transform: uppercase; color: #444;
    margin-bottom: 14px; display: flex; align-items: center; gap: 8px;
  }
  .up-block-label span { color: #7b10e0; }

  /* ---- SECTION CONTENU TEXTE ---- */
  .up-content-grid {
    display: grid; grid-template-columns: 1.3fr 0.7fr; gap: 60px; align-items: start;
  }
  .up-content-title {
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 900; font-size: 2.2rem; text-transform: uppercase;
    color: rgba(255,255,255,0.07); margin-bottom: 24px;
  }
  .up-aside-card {
    background: #111; border: 1px solid rgba(255,255,255,0.07);
    padding: 22px 20px; margin-bottom: 12px;
  }
  .up-aside-card:last-child { margin-bottom: 0; }
  .up-aside-card-title {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.62rem; font-weight: 700; letter-spacing: 0.2em;
    text-transform: uppercase; color: #444;
    padding-bottom: 12px; margin-bottom: 14px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }

  /* ---- GALERIE ---- */
  .up-gallery-header {
    display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;
  }
  .up-gallery-title {
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 900; font-size: 1.6rem; text-transform: uppercase;
  }
  .up-gallery-count {
    font-family: 'Space Mono', monospace; font-size: 0.7rem; color: #7b10e0;
  }
  .up-gallery-grid {
    display: grid; grid-template-columns: repeat(3, 1fr);
    gap: 2px; background: rgba(255,255,255,0.05);
  }

  /* ---- SAVE BAR ---- */
  .up-savebar {
    position: sticky; bottom: 0; z-index: 50;
    background: rgba(8,8,8,0.97); backdrop-filter: blur(16px);
    border-top: 1px solid rgba(255,255,255,0.07);
    padding: 14px 80px;
    display: flex; align-items: center; justify-content: space-between; gap: 16px;
  }
  .up-savebar-info {
    font-size: 0.78rem; color: #444; font-weight: 300;
  }
  .up-savebar-info strong { color: #f0f0f0; font-weight: 500; }
  .up-savebar-right { display: flex; align-items: center; gap: 12px; }
  .up-toast {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 0.72rem; font-weight: 700; letter-spacing: 0.12em;
    text-transform: uppercase; color: #00E5FF;
    opacity: 0; transition: opacity 0.3s; white-space: nowrap;
  }
  .up-toast.show { opacity: 1; }

  /* ---- ERRORS ---- */
  .up-error-banner {
    background: rgba(255,68,68,0.08); border: 1px solid rgba(255,68,68,0.25);
    padding: 14px 20px; margin-bottom: 20px;
    font-size: 0.8rem; color: #ff7777; font-weight: 300;
  }

  /* ---- RESPONSIVE ---- */
  @media (max-width: 1024px) {
    .up-topbar, .up-selector, .up-section, .up-hero-img-wrap,
    .up-savebar { padding-left: 40px; padding-right: 40px; }
    .up-section-inner-2col, .up-content-grid { grid-template-columns: 1fr; gap: 32px; }
    .up-gallery-grid { grid-template-columns: repeat(2, 1fr); }
  }
  @media (max-width: 640px) {
    .up-topbar, .up-selector, .up-section, .up-hero-img-wrap,
    .up-savebar { padding-left: 16px; padding-right: 16px; }
    .up-topbar { flex-direction: column; align-items: flex-start; gap: 20px; }
    .up-topbar-actions { width: 100%; flex-wrap: wrap; }
    .up-btn { flex: 1; justify-content: center; }
    .up-selector { flex-direction: column; align-items: flex-start; }
    .up-selector select { width: 100%; min-width: unset; }
    .up-field-row { grid-template-columns: 1fr; }
    .up-gallery-grid { grid-template-columns: 1fr 1fr; }
    .up-savebar { flex-direction: column; align-items: flex-start; gap: 12px; }
    .up-savebar-right { width: 100%; justify-content: flex-end; }
    .up-section-inner-2col, .up-content-grid { grid-template-columns: 1fr; gap: 28px; }
  }
`;

/* ============================================================
   CONSTANTES
============================================================ */
const CATEGORIES = [
  { key: 'identite',     label: 'Identité Visuelle' },
  { key: 'ui',           label: 'UI / UX Design' },
  { key: 'motion',       label: 'Motion Design' },
  { key: 'print',        label: 'Print & Édition' },
  { key: 'illustration', label: 'Illustration' },
];

const EMPTY = {
  id: null, name: '', cat: 'identite', catLabel: 'Identité Visuelle',
  desc: '', bg: 'project-bg-1', letter: '', client: '', date: '', role: '',
  tools: [], context: '', approach: '', result: '',
  heroImage: '', heroLetter: '', heroBg: 'linear-gradient(135deg,#130508,#2a0d12,#130508)',
  images: ['', '', '', '', ''],
  imageBgs: [
    'linear-gradient(135deg,#1a0808,#3d1010)',
    'linear-gradient(135deg,#0a0a1a,#18182e)',
    'linear-gradient(135deg,#0a1a0a,#102810)',
    'linear-gradient(135deg,#1a1a0a,#282808)',
    'linear-gradient(135deg,#1a0a1a,#280e28)',
  ],
};

/* ---- Helpers ---- */
function toBase64(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
}

/* ---- Zone upload image ---- */
function ImgZone({ value, onChange, sizeClass = 'hero', label = 'Image' }) {
  const [drag, setDrag] = useState(false);
  const ref = useRef();

  const handle = async (file) => {
    if (!file?.type.startsWith('image/')) return;
    onChange(await toBase64(file));
  };

  return (
    <div
      className={`up-img-zone ${sizeClass} ${drag ? 'dragover' : ''}`}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); handle(e.dataTransfer.files[0]); }}
    >
      {value ? (
        <div style={{ position: 'relative' }}>
          <img src={value} alt="preview" />
          <button className="up-img-remove" onClick={(e) => { e.stopPropagation(); onChange(''); }}>
            ✕ Retirer
          </button>
        </div>
      ) : (
        <>
          <input ref={ref} type="file" accept="image/*" onChange={(e) => handle(e.target.files[0])} />
          <div className="up-img-placeholder">
            <div className="up-img-icon">⊕</div>
            <div className="up-img-text">{label}</div>
            <div className="up-img-sub">JPG · PNG · WebP — max 5 Mo</div>
          </div>
        </>
      )}
    </div>
  );
}

/* ============================================================
   PAGE PRINCIPALE
============================================================ */
export default function UploadProjet() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [selId, setSelId]       = useState('new');
  const [form, setForm]         = useState({ ...EMPTY, id: Date.now() });
  const [toolInput, setToolInput] = useState('');
  const [errors, setErrors]     = useState({});
  const [toast, setToast]       = useState('');

  /* Inject styles */
  useEffect(() => {
    const tag = document.createElement('style');
    tag.id = 'upload-styles';
    tag.textContent = STYLES;
    document.head.appendChild(tag);
    document.title = 'Upload Projet — HEYIMPURP';
    setProjects(getProjects());
    return () => { document.getElementById('upload-styles')?.remove(); };
  }, []);

  /* Changer de projet sélectionné */
  useEffect(() => {
    if (selId === 'new') {
      setForm({ ...EMPTY, id: Date.now() });
    } else {
      const p = getProjects().find(p => String(p.id) === selId);
      if (p) setForm({ ...EMPTY, ...p, tools: p.tools || [], images: p.images || ['','','','',''] });
    }
    setErrors({});
  }, [selId]);

  /* ---- Helpers form ---- */
  const set = (field) => (e) => {
    const val = e.target.value;
    setForm(f => {
      const u = { ...f, [field]: val };
      if (field === 'cat') { const c = CATEGORIES.find(c => c.key === val); if (c) u.catLabel = c.label; }
      if (field === 'name') { u.heroLetter = val.trim()[0]?.toUpperCase() || ''; u.letter = u.heroLetter; }
      return u;
    });
    if (errors[field]) setErrors(e => ({ ...e, [field]: false }));
  };

  const setImg       = (field) => (val) => setForm(f => ({ ...f, [field]: val }));
  const setGalleryImg = (idx) => (val) => setForm(f => {
    const imgs = [...(f.images || ['','','','',''])];
    imgs[idx] = val;
    return { ...f, images: imgs };
  });

  const addTool = () => {
    const t = toolInput.trim();
    if (!t || form.tools.includes(t)) { setToolInput(''); return; }
    setForm(f => ({ ...f, tools: [...f.tools, t] }));
    setToolInput('');
  };
  const removeTool = (t) => setForm(f => ({ ...f, tools: f.tools.filter(x => x !== t) }));

  /* ---- Validation ---- */
  const validate = () => {
    const e = {};
    if (!form.name.trim())   e.name   = true;
    if (!form.client.trim()) e.client = true;
    if (!form.desc.trim())   e.desc   = true;
    return e;
  };

  /* ---- Toast ---- */
  const flash = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(''), 2800);
  };

  /* ---- Sauvegarde ---- */
  const save = (quiet = false) => {
    const e = validate();
    if (Object.keys(e).length) {
      setErrors(e);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    const all = getProjects();
    const idx = all.findIndex(p => p.id === form.id);
    const updated = idx >= 0 ? all.map(p => p.id === form.id ? { ...form } : p) : [...all, { ...form }];
    localStorage.setItem('projects', JSON.stringify(updated));
    setProjects(updated);
    if (selId === 'new') setSelId(String(form.id));
    if (!quiet) flash('Projet sauvegardé ✓');
    return true;
  };

  const handleDelete = () => {
    if (!window.confirm(`Supprimer "${form.name || 'ce projet'}" ? Irréversible.`)) return;
    const updated = getProjects().filter(p => p.id !== form.id);
    localStorage.setItem('projects', JSON.stringify(updated));
    setProjects(updated);
    setSelId('new');
    flash('Projet supprimé');
  };

  const handlePreview = () => {
    if (save(true)) navigate(`/projet/${form.id}`);
  };

  const nbImgs = (form.images || []).filter(Boolean).length;
  const hasErrors = Object.keys(errors).length > 0;

  return (
    <div className="up-page">
      <Nav />

      {/* ===== TOP BAR ===== */}
      <div className="up-topbar">
        <div className="up-topbar-left">
          <div className="up-topbar-eyebrow">Administration</div>
          <h1 className="up-topbar-title">UPLOAD <span>PROJET</span></h1>
        </div>
        <div className="up-topbar-actions">
          {selId !== 'new' && (
            <button className="up-btn up-btn-danger" onClick={handleDelete}>Supprimer</button>
          )}
          <button className="up-btn up-btn-ghost" onClick={handlePreview}>Prévisualiser →</button>
          <button className="up-btn up-btn-primary" onClick={() => save(false)}>Sauvegarder</button>
        </div>
      </div>

      {/* ===== SÉLECTEUR ===== */}
      <div className="up-selector">
        <span className="up-selector-label">Projet :</span>
        <select value={selId} onChange={(e) => setSelId(e.target.value)}>
          <option value="new">+ Nouveau projet</option>
          {projects.map(p => (
            <option key={p.id} value={String(p.id)}>{p.name || '(sans titre)'}</option>
          ))}
        </select>
        <button className="up-btn up-btn-ghost up-btn-sm" onClick={() => setSelId('new')}>+ Nouveau</button>
        <span className="up-selector-sep">|</span>
        <Link to="/portfolio" className="up-selector-link">← Voir le portfolio</Link>
      </div>

      <div className="up-body">

        {/* ===== SECTION 1 : INFOS PRINCIPALES ===== */}
        <div className="up-section">
          <div className="up-section-eyebrow">Informations principales</div>

          {hasErrors && (
            <div className="up-error-banner">
              Champs requis manquants — vérifiez le nom, le client et la description.
            </div>
          )}

          <div className="up-section-inner-2col">

            {/* Colonne gauche — comme .project-hero-left */}
            <div>
              {/* Titre en grand — aperçu live */}
              <div className={`up-title-preview ${form.name ? 'active' : ''}`}>
                {form.name || 'NOM DU PROJET'}
              </div>

              <div className="up-field">
                <div className="up-field-label">
                  Nom du projet <em>*</em>
                </div>
                <input
                  type="text"
                  placeholder="ex : NOVA STUDIO"
                  value={form.name}
                  onChange={set('name')}
                  className={errors.name ? 'err' : ''}
                />
              </div>

              <div className="up-field">
                <div className="up-field-label">
                  Description courte <em>*</em>
                  <small>{form.desc.length}/300 car.</small>
                </div>
                <textarea
                  placeholder="Accroche affichée sur la carte portfolio et en tête de la page projet..."
                  value={form.desc}
                  onChange={set('desc')}
                  className={errors.desc ? 'err' : ''}
                  rows={3}
                  maxLength={300}
                />
              </div>

              <div className="up-field">
                <div className="up-field-label">Catégorie</div>
                <select value={form.cat} onChange={set('cat')}>
                  {CATEGORIES.map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
                </select>
              </div>

              <div className="up-field">
                <div className="up-field-label">
                  Outils utilisés
                  <small>Entrée pour valider</small>
                </div>
                <div className="up-tools-wrap">
                  {form.tools.map(t => (
                    <div className="up-tool-tag" key={t}>
                      {t}
                      <button className="up-tool-remove" onClick={() => removeTool(t)}>✕</button>
                    </div>
                  ))}
                </div>
                <div className="up-tool-add">
                  <input
                    type="text"
                    placeholder="Figma, Illustrator, After Effects..."
                    value={toolInput}
                    onChange={(e) => setToolInput(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addTool(); } }}
                  />
                  <button className="up-btn up-btn-ghost up-btn-sm" onClick={addTool}>+ Ajouter</button>
                </div>
              </div>
            </div>

            {/* Colonne droite — comme .project-meta */}
            <div className="up-meta-block">
              <div className="up-meta-row">
                <div className="up-meta-row-label">Client <span style={{ color: '#7b10e0' }}>*</span></div>
                <input
                  type="text"
                  placeholder="Nom du client ou de la marque"
                  value={form.client}
                  onChange={set('client')}
                  className={errors.client ? 'err' : ''}
                />
              </div>
              <div className="up-meta-row">
                <div className="up-meta-row-label">Date de réalisation</div>
                <input
                  type="text"
                  placeholder="ex : Mars 2025"
                  value={form.date}
                  onChange={set('date')}
                />
              </div>
              <div className="up-meta-row">
                <div className="up-meta-row-label">Catégorie</div>
                <input type="text" value={form.catLabel} readOnly style={{ color: '#666' }} />
              </div>
              <div className="up-meta-row">
                <div className="up-meta-row-label">Rôle / Mission</div>
                <input
                  type="text"
                  placeholder="Direction artistique, Design de logo..."
                  value={form.role}
                  onChange={set('role')}
                />
              </div>
            </div>

          </div>
        </div>

        {/* ===== SECTION 2 : IMAGE PRINCIPALE ===== */}
        <div className="up-hero-img-wrap">
          <div className="up-block-label">
            Image <span>principale</span> — bannière pleine largeur
          </div>
          <ImgZone
            value={form.heroImage}
            onChange={setImg('heroImage')}
            sizeClass="hero"
            label="Glissez ou cliquez pour uploader l'image principale (format paysage recommandé)"
          />
        </div>

        {/* ===== SECTION 3 : TEXTES ===== */}
        <div className="up-section">
          <div className="up-section-eyebrow">Contexte &amp; Mission</div>
          <div className="up-content-grid">

            <div>
              <div className="up-content-title">LE PROJET</div>
              <div className="up-field">
                <div className="up-field-label">Contexte du projet</div>
                <textarea
                  placeholder="Quelle était la situation initiale ? Pourquoi ce projet a-t-il été lancé ?"
                  value={form.context}
                  onChange={set('context')}
                  rows={5}
                />
              </div>
              <div className="up-field">
                <div className="up-field-label">Approche &amp; Process</div>
                <textarea
                  placeholder="Comment avez-vous travaillé ? Quelle méthode, quelles étapes ?"
                  value={form.approach}
                  onChange={set('approach')}
                  rows={5}
                />
              </div>
            </div>

            <div>
              <div className="up-aside-card">
                <div className="up-aside-card-title">Résultats</div>
                <div className="up-field" style={{ marginBottom: 0 }}>
                  <textarea
                    placeholder="Retours, chiffres, impact mesurable..."
                    value={form.result}
                    onChange={set('result')}
                    rows={5}
                  />
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ===== SECTION 4 : GALERIE ===== */}
        <div className="up-section">
          <div className="up-gallery-header">
            <h2 className="up-gallery-title">GALERIE</h2>
            <span className="up-gallery-count">{nbImgs} / 5 images</span>
          </div>
          <div className="up-gallery-grid">
            {(form.images || ['','','','','']).map((img, i) => (
              <ImgZone
                key={i}
                value={img}
                onChange={setGalleryImg(i)}
                sizeClass="thumb"
                label={`Visuel ${i + 1}`}
              />
            ))}
          </div>
        </div>

      </div>{/* end up-body */}

      {/* ===== SAVE BAR STICKY ===== */}
      <div className="up-savebar">
        <div className="up-savebar-info">
          <strong>{form.name || 'Nouveau projet'}</strong>
          {' — '}{nbImgs} image{nbImgs > 1 ? 's' : ''} · {form.tools.length} outil{form.tools.length > 1 ? 's' : ''}
        </div>
        <div className="up-savebar-right">
          <span className={`up-toast ${toast ? 'show' : ''}`}>{toast}</span>
          <button className="up-btn up-btn-ghost up-btn-sm" onClick={handlePreview}>Prévisualiser →</button>
          <button className="up-btn up-btn-primary" onClick={() => save(false)}>Sauvegarder</button>
        </div>
      </div>

      <Footer />
    </div>
  );
}
